import { easeIn } from "framer-motion";
import { mediaData } from "./mediaData";

const USE_PARENT_URL = process.env.REACT_APP_USE_PARENT_URL;
const PARENT_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PARENT_URL_PRODUCTION : process.env.REACT_APP_PARENT_URL_STAGING;

const dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
export const callGA = (
  eventCategory,
  eventLabel,
  modelName,
  fuelType,
  trafficSource,
  utmMedium,
  utmCampaign,
  utmContent,
  storyId,
  chapterId,
  storyName,
  set
) => {
  gtag("event", eventCategory, {
    click: eventLabel,
    model_name: `${modelName}_${fuelType}`,
    traffic_source: trafficSource,
    traffic_medium: utmMedium,
    traffic_campaign: utmCampaign,
    traffic_content: utmContent,
    story_id: storyId,
    chapter_id: chapterId,
    story_name: storyName,
    set
  });
};

const getQueryParams = (url) => {
  const urlParams = new URLSearchParams(url);
  const queryParams = {};

  urlParams.forEach((value, key) => {
    queryParams[key] = value;   

  });

  return queryParams;
}

export const getCurrentUrl = () => {
  let parentUrl = '';
  if (USE_PARENT_URL === 'true') {
    parentUrl = PARENT_URL;
  } else {
    parentUrl = window.location.origin;
  }

  const queryParams = getQueryParams(window.location.search);
  const queryString = `modelId=${queryParams['modelId']}${queryParams['pplId'] ? `&pplId=${queryParams['pplId']}` : ''}&story_id=${queryParams['story_id']}&utm_source=Webapp&utm_medium=Organic&utm_campaign=Curvv_EV_Experience&utm_content=Web_share`;

  return `${parentUrl}?${queryString}`;
}

export const storyChangeAnimSlide = {
  initial: {
    opacity: 0,
    transition: { duration: 1, ease: "easeIn" },
  },
  active: {
    x: 0,
    opacity: 1,
    transition: { duration: 1, ease: "easeIn" },
  },
  exit: {
    x: "-100%",
    transition: { duration: 0.2, ease: "easeInOut" },
  },
};

export const storyChangeAnim = {
  initial: {
    opacity: 0,
    transition: { duration: 0.5, ease: "easeIn" },
  },
  active: {
    opacity: 1,
    transition: { duration: 1, ease: "easeIn" },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0, ease: "easeInOut" },
  },
};

export const wrapperAnim = {
  initial: { opacity: 1 },
  animate: {
    opacity: 1,
    transition: {
      delay: 3,
      ease: easeIn,
      staggerChildren: 0.5,
      delayChildren: 1,
    },
  },
};

export const childAnim = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      ease: easeIn,
    },
  },
};

export const wrapperAnimEnd = {
  initial: { opacity: 1 },
  animate: {
    opacity: 1,
    transition: {
      delay: 0.1,
      ease: easeIn,
      staggerChildren: 0.5,
      delayChildren: 1,
    },
  },
};

export const childAnimEnd = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      ease: easeIn,
    },
  },
};

export const FEEDBACK_OPTIONS = [
  {
    key: 'smooth_ride',
    title: 'smooth ride!',
    icon: mediaData['smoothRideIcon'],
    value: 'Smooth_ride',
  },
  {
    key: 'bumpy',
    title: 'A bit bumpy',
    icon: mediaData['bumpyIcon'],
    value: 'Bumpy',
  },
  {
    key: 'not_great',
    title: 'not great',
    icon: mediaData['notGreatIcon'],
    value: 'Not_great',
  }
];

export const FEEDBACK_STARS = 5;